var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-select',{attrs:{"items":_vm.seasons,"menu-props":_vm.menuProps,"label":"Season","dense":"","hide-details":"","outlined":""},model:{value:(_vm.season),callback:function ($$v) {_vm.season=$$v},expression:"season"}})
}
var staticRenderFns = []

export { render, staticRenderFns }